import React from 'react';
import { Box, Center, VStack } from '@chakra-ui/react';
import { Services_COPO } from './Services_COPO';
import { Services_HRPR } from './Services_HRPR';

export const Services = (props) => {
	return (
		<Center className={`services-page-center ${props.top}`}>
			<VStack>
				<Box className='services-vstack'>
					<Services_COPO />
				</Box>
				<Box>
					<Services_HRPR />
				</Box>
			</VStack>
		</Center>
	);
};
